import { useMembershipStore } from '@/stores/membership'
import type { NuxtApp } from '#app'

export default defineNuxtPlugin(({ $restClient }: NuxtApp) => {
  const membershipStore = useMembershipStore()

  const loadMembershipStatuses = async () => {
    const membershipStatuses = await $restClient.getMembershipStatuses({
      slugs: ['subscriber', 'trial', 'special-issues'],
    })

    // Temporarily manually adding the special issues subscription as those should be accessible to all authenticated users
    membershipStatuses.push({
      expiration_date: '2034-09-20 00:00:00',
      name: 'Special Issues',
      slug: 'special-issues',
      status: 'active',
    })

    membershipStore.setMembershipStatuses(membershipStatuses)
  }

  return {
    provide: {
      membership: {
        loadMembershipStatuses,
      },
    },
  }
})
